import { render, staticRenderFns } from "./firstchoose.vue?vue&type=template&id=202ab0f8&scoped=true&"
import script from "./firstchoose.vue?vue&type=script&lang=js&"
export * from "./firstchoose.vue?vue&type=script&lang=js&"
import style0 from "./firstchoose.vue?vue&type=style&index=0&id=202ab0f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202ab0f8",
  null
  
)

export default component.exports